(() => {
  if (window.emmeDefyLaunchMounted) return;
  window.emmeDefyLaunchMounted = true;
  const instances = new Map();

  function mount(root) {
    if (instances.has(root)) return;
    const slot = root.querySelector('[data-defy-rotator]');
    const word = slot?.querySelector('[data-defy-word]');
    const motion = root.querySelector('[data-defy-motion]');
    if (!slot || !word || !motion) return;
    const abort = new AbortController();
    const on = (target, event, handler) => target.addEventListener(event, handler, { signal: abort.signal });
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const pauseIcon = motion.querySelector('[data-defy-pause]');
    const playIcon = motion.querySelector('[data-defy-play]');
    const finalWord = slot.dataset.finalWord;
    const words = [slot.dataset.wordOne, slot.dataset.wordTwo, slot.dataset.wordThree].filter(value => value?.trim());
    words.push(finalWord);
    const timers = new Set();
    let paused = false;
    let inView = !('IntersectionObserver' in window);
    let observer;
    const clear = () => { timers.forEach(clearTimeout); timers.clear(); };
    const after = (delay, action) => {
      const id = setTimeout(() => { timers.delete(id); action(); }, delay);
      timers.add(id);
    };

    function play(index) {
      word.classList.remove('is-struck');
      word.classList.add('is-hidden');
      word.textContent = words[index];
      after(60, () => word.classList.remove('is-hidden'));
      if (index < words.length - 1) {
        after(1000, () => word.classList.add('is-struck'));
        after(1800, () => word.classList.add('is-hidden'));
        after(2250, () => play(index + 1));
      } else {
        after(4200, () => word.classList.add('is-hidden'));
        after(4700, () => play(0));
      }
    }

    function sync() {
      clear();
      word.textContent = finalWord;
      word.classList.remove('is-hidden', 'is-struck');
      motion.hidden = preference.matches || words.length < 2;
      motion.setAttribute('aria-label', paused ? motion.dataset.playLabel : motion.dataset.pauseLabel);
      if (pauseIcon) pauseIcon.hidden = paused;
      if (playIcon) playIcon.hidden = !paused;
      const playing = !preference.matches && !paused && !document.hidden && inView && words.length > 1;
      root.classList.toggle('has-motion', !preference.matches && words.length > 1);
      root.classList.toggle('is-playing', playing);
      if (playing) play(0);
    }

    instances.set(root, () => {
      clear();
      abort.abort();
      observer?.disconnect();
      root.classList.remove('is-playing');
      instances.delete(root);
    });
    on(motion, 'click', () => { paused = !paused; sync(); });
    on(preference, 'change', sync);
    on(document, 'visibilitychange', sync);
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        const visible = entries.some(entry => entry.isIntersecting);
        if (visible !== inView) { inView = visible; sync(); }
      });
      observer.observe(root);
    }
    sync();
  }

  function scan(scope) {
    if (scope.matches?.('[data-defy-launch]')) mount(scope);
    scope.querySelectorAll('[data-defy-launch]').forEach(mount);
  }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of instances) if (event.target.contains(root)) cleanup();
  });
})();
